<script lang="ts" setup>
import type { ISOPROProduct } from '~/models';

interface Props {
  product: ISOPROProduct;
  index: number;
}

defineProps<Props>();

defineEmits<{
  (e: 'selectedProduct', product: ISOPROProduct): void;
}>();
</script>

<template>
  <li class="product-list__item" :value="index" @click="$emit('selectedProduct', product)" :cypress-id="`product:${product.rowKey}`">
    <img :src="product.imageURL" :alt="product.rowKey" loading="lazy" />
    <div class="row-key">{{ product.rowKey }}</div>
  </li>
</template>


<style lang="scss" scoped>
$height: 50px;

.product-list__item {
  border: 1px solid black;
  cursor: pointer;
  display: grid;
  grid-template-columns: $height 1fr;
  align-items: center;
  column-gap: 20px;
  margin: 2px;
  text-align: left;
  height: max-content;

  img {
    width: $height;
    height: $height;
    object-fit: contain;
    mix-blend-mode: darken;
  }

  &:hover {
    background-color: var(--hover-background-color);
    opacity: var(--hover-opacity);
  }

  &.active {
    color: var(--bds-brand-primary-color);
    border: 2px solid var(--bds-brand-primary-color);
    font-weight: 700;
    margin: 0;

    img {
      width: calc(#{$height} + 2px);
      height: calc(#{$height} + 2px);
      object-fit: contain;
    }
  }
}
</style>
